'use strict';

var _classCallCheck = require("/Volumes/Workstation/projects/mak-tender/MAK-TENDER-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Volumes/Workstation/projects/mak-tender/MAK-TENDER-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RandomStringConfig = void 0;
var RandomStringConfig = /*#__PURE__*/function () {
  /**
   * Create a new instance.
   */
  function RandomStringConfig() {
    _classCallCheck(this, RandomStringConfig);
    this.config = {
      length: 21,
      numbers: false,
      symbols: false,
      characters: false
    };
  }
  /**
   * Returns the configured string length.
   *
   * @returns {Number}
   */
  _createClass(RandomStringConfig, [{
    key: "length",
    value: function length() {
      return this.config.length;
    }
    /**
     * Assign the given `length`.
     *
     * @param length
     *
     * @returns {this}
     */
  }, {
    key: "withLength",
    value: function withLength(length) {
      if (length) {
        this.config.length = length;
      }
      return this;
    }
    /**
     * Use characters when generating a random string.
     *
     * @returns {this}
     */
  }, {
    key: "useCharacters",
    value: function useCharacters() {
      this.config.characters = true;
      return this;
    }
    /**
     * Determine whether to use characters when generating a random string.
     *
     * @returns {this}
     */
  }, {
    key: "shouldUseCharacters",
    value: function shouldUseCharacters() {
      return this.config.characters;
    }
    /**
     * Use numbers when generating a random string.
     *
     * @returns {this}
     */
  }, {
    key: "useNumbers",
    value: function useNumbers() {
      this.config.numbers = true;
      return this;
    }
    /**
     * Determine whether to use numbers when generating a random string.
     *
     * @returns {this}
     */
  }, {
    key: "shouldUseNumbers",
    value: function shouldUseNumbers() {
      return this.config.numbers;
    }
    /**
     * Use symbols when generating a random string.
     *
     * @returns {this}
     */
  }, {
    key: "useSymbols",
    value: function useSymbols() {
      this.config.symbols = true;
      return this;
    }
    /**
     * Determine whether to use numbers when generating a random string.
     *
     * @returns {this}
     */
  }, {
    key: "shouldUseSymbols",
    value: function shouldUseSymbols() {
      return this.config.symbols;
    }
  }]);
  return RandomStringConfig;
}();
exports.RandomStringConfig = RandomStringConfig;